module.exports = __webpack_public_path__ + "img/emoji_99.ae92e455.png";